<template lang="pug">
.subscribe-modal
  y-dialog(v-model="dialog" persistent scrollable :fullscreen="$vuetify.breakpoint.xsOnly" max-width="600px" content-class="round-2xl")
    v-card(min-height="80vh")
      v-card-title.px-4
        v-layout
          eva-icon.mr-4(name="close-outline" :fill="$vuetify.theme.themes[$theme].primary500" @click="dialog = false")
          .font-bold.text-lg(v-if="step != 0") Clinic CMS Subscription
      v-card-text.px-4.primary--text
        y-stepper.mb-8(v-if="step > 0 && step < 5" :currentStep="step" :steps="steps")
        v-window(v-model="step" touchless)
          v-window-item.px-2(:value="0")
            .font-semibold.text-2xl.mb-1 {{ steps[step].title }}
            .text-sm.mb-6 Here’s a summary of what you can get with Clinic CMS

            .mb-8
              v-card.pa-4.round-xl.mb-4(flat color="neutral300")
                .text-md.font-medium Manage your patients end-to-end from front desk registration, queue management, EMR, dispensary, and billing.
              v-card.pa-4.round-xl.mb-4(flat color="neutral300")
                .text-md.font-medium Automate daily inventory count. Understand the health of your business.
              v-card.pa-4.round-xl(flat color="neutral300")
                .text-md.font-medium Manage Doctor's and Procedure availability in one place

            .text-md.font-semibold Would you like to subscribe with with Clinic CMS?

          v-window-item(:value="1")
            // =========================================================================================================
            //  1. Choose your plan
            // =========================================================================================================
            v-layout.pa-6(v-if="!planGroup")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            .contracts(v-else)

              v-card.pa-4.mb-4.round-xl(outlined v-for="(contract, index) in contracts" :key="contract.code" :style="contract.selected ? 'border:2px solid var(--v-textColorAccent)' : 'border:2px solid var(--v-basic300)'" :color="contract.data.extra_data[planVersion].recommended ? $vuetify.theme.themes[$theme].successT08: $vuetify.theme.themes[$theme].basic600T08")
                div(@click="selectContract(contract)")
                  div.d-flex.align-center
                    div.h5.textColor--text {{ contract.data.extra_data[planVersion].name }}
                    div.ml-2(v-if="contract.selected" )
                      v-avatar.my-auto(:color='$vuetify.theme.themes[$theme].textColorAccent' size=20)
                        eva-icon(name="checkmark-outline" :fill="$vuetify.theme.themes[$theme].basic100" width="18" height="18" style="margin-top:3px; margin-left: 1px;")
                    v-spacer
                    div.h4.textColor--text.text-right(style="") {{ contract.data.original_price/100 }}

                  v-row.mt-3(no-gutters)
                    v-col
                      .s1.success500--text(v-if="contract.data.extra_data[planVersion].recommended") Recommended for you!
                      .p1.primary500--text {{ contract.data.extra_data[planVersion].promo_text }}
                    v-col
                      .p2.primary400--text.text-right {{ contract.data.extra_data[planVersion].bill_line_1 }}
                      .p2.primary400--text.text-right(v-if="!cmsSubscription.value") {{ contract.data.extra_data[planVersion].bill_line_2 }}


          v-window-item(:value="2")
            // =========================================================================================================
            //  2. Select payment method
            // =========================================================================================================
            .h5.textColor--text.text-center Select payment method
            v-card.mt-8(flat outlined style="border:1px solid var(--v-basic300);")
              v-radio-group.mt-n1(v-model="selectedPaymentMethod" hide-details)
                v-layout(style="cursor: pointer" @click="selectedPaymentMethod = 'card'")
                  v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                    eva-icon.ma-auto(name="credit-card-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                  v-col.pa-0.my-auto
                    v-layout.py-4
                      div.my-auto.pr-2
                        .s1.basic800--text Credit or debit card
                  v-col.pa-0.shrink.mt-5
                    v-radio.my-0.py-0.mr-2(value="card" readonly)
                v-divider.basic300
                template(v-if="selectedContract")
                  v-layout(:style="selectedContract.data.billing_cycle === 'monthly' ? 'cursor: default' : 'cursor: pointer'" @click="selectedContract.data.billing_cycle === 'monthly' ? '' : selectedPaymentMethod = 'fpx'")
                    v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                      BuildingBankIcon.ma-auto(size="24" :style="selectedContract.data.billing_cycle === 'yearly' ? 'color: var(--v-basic700)' : 'color: var(--v-basic500)'")
                    v-col.pa-0.my-auto
                      v-layout.py-4
                        div.my-auto.pr-2
                          .s1(:class="selectedContract.data.billing_cycle === 'yearly' ? 'basic800--text' : 'basic500--text' ") Online banking
                          .c1.basic500--text(v-if="selectedContract.data.billing_cycle === 'monthly'") For yearly contract only
                    v-col.pa-0.shrink.mt-5
                      v-radio.my-0.py-0.mr-2(value="fpx" readonly)

            v-card.pa-4.mt-8(v-if="selectedPaymentMethod" flat outlined style="border:1px solid var(--v-basic300);")
              card-list.mt-4(v-if="selectedPaymentMethod === 'card'" @change="form.card = $event.id")
              .online-payment.mt-4(v-else-if="selectedPaymentMethod === 'fpx'" )
                div.subtitle.mb-3 Choose bank for payment
                v-card.mb-12
                  FPXPicker(v-model="fpxBankCode")
          v-window-item.text-center(v-if="selectedContract" :value="3")
            // =========================================================================================================
            //  3. Confirm your subscription
            // =========================================================================================================
            .h5.textColor--text.text-center.mb-8 Confirm your subscription
            .h3.mt-6.textColor--text Clinic {{ selectedContract.data.billing_cycle | capitalize }}
            .h1.text-center.mt-4 {{ selectedContract.data.price/100 }}
            .p1.primary400--text.mt-4 RM per {{ selectedContract.data.billing_cycle.replace('ly', '') }} with {{ selectedContract.data.billing_cycle }} contract
            .p2.text-center.success500--text.mt-2(v-if="selectedContract.data.confirm_promo_description") {{ selectedContract.data.confirm_promo_description }}

            .extra.mt-4(v-if="addOn.selected" v-for="(addOn, index) in selectedContract.data.add_ons" :key="'confirmation' + addOn.id")
              .s1.textColor--text + {{ addOn.feature.name }}
              .p1.primary400--text
                span (RM{{ addOn.price/100 }} per {{ selectedContract.data.billing_cycle.replace('ly', '') }}, billed {{ selectedContract.data.billing_cycle }})

          v-window-item(:value="4")
            // =========================================================================================================
            //  4. Thank you
            // =========================================================================================================
            .h5.textColor--text.mb-8.text-center Subscription successful!
            v-container.text-center
              .text-sm.primary400--text.mb-1 Thank you for giving us the opportunity to help you grow further and bigger.
              .text-sm.mb-6.primary400--text Let’s do this together.
              y-button(label="Finish" @click="finish" color="info")
              
          v-window-item(:value="5")
            // =========================================================================================================
            //  4. Payment failed
            // =========================================================================================================
            .h5.textColor--text.mb-8.text-center Payment failed
            v-container.text-center
              .p1.primary400--text The payment did not go through, please try again.
              v-btn.mt-4(color="info500" dark @click="retryPayment" depressed height=32 )
                .button-AA-medium.basic100--text Retry Payment

      v-divider.basic300(v-if="step == 1")
      v-card-actions.basic200.px-4(v-if="step == 1 && selectedContract")
        v-col.pa-0
          .text-sm.font-medium Selected plan:
          v-layout
            .text-sm {{ selectedContract.data.billing_cycle | capitalize }} contract
            v-spacer
            .text-sm {{ selectedContract.data.price | displayPriceRM }}
          v-layout(v-if="addOn.selected" v-for="(addOn, index) in selectedContract.data.add_ons" :key="'selected' + addOn.id")
            .text-sm + {{ addOn.feature.name }}
            v-spacer
            .text-sm {{ addOn.price | displayPriceRM }}
      
      v-divider.basic400(v-if="step == 1")
      v-card-actions.pa-4(:class="step == 1? 'basic200' : ''" v-if="steps[step].primaryButton")
        v-spacer
        y-button(:label="steps[step].secondaryButton" @click="previousStep" color="transparent" textColor="neutral500")
        y-button(:label="steps[step].primaryButton" @click="nextStep" color="info" :loading="isLoading" :disabled="steps[step].disabled")

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { setOptions, bootstrap } from 'vue-gtag'
import CardList from '@/components/billing/CardList.vue'
import FPXPicker from '@/components/FPXPicker.vue'
import Cookies from 'js-cookie'

export default {
  name: "SubscribeCmsModal",
  components: { CardList, FPXPicker },
  props: ['open', 'company', 'volunteer', 'paymentCallback'],
  data: (v) => ({
    json: {
      name: 'Monthly plan',
      recommended: false,
      promo_text: '',
      bill_line_1: 'RM per month',
      bill_line_2: ''
    },
    isFetching: false,
    step: 0,
    planGroup: null,
    planVersion: 'v1.0',
    contracts: [],
    selectedContract: null,
    form: {
      company: v.company.id,
      contract: null,
      card: null
    },
    isLoading: false,
    selectedPaymentMethod: null,
    fpxBankCode: null,
    retryPaymentLoading: false,
    statistics: {
      sales: 0,
      potential_sales: 0,
      total_expenses: 0,
      biggest_expense_category: null,
      biggest_expense_amount: 0,
    }
  }),
  computed: {
    ...mapState('subscriptions', ['cmsTrial', 'cmsSubscription']),
    authMember () {
      return this.$store.state.user.member
    },
    dialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    steps () {
      return [
        { title: this.volunteer ? 'Subscribe to Clinic CMS' : 'Trial has ended', hidden: true, secondaryButton: 'Subscribe later', primaryButton: 'Show me pricing' },
        { title: 'Select plan', hidden: false, secondaryButton: 'Back', primaryButton: 'Next' },
        { title: 'Payment', hidden: false, secondaryButton: 'Back', primaryButton: 'Next', disabled: !this.selectedPaymentMethod ? true : (this.selectedPaymentMethod === 'card' ? !this.form.card : !this.fpxBankCode) },
        { title: 'Confirmation', hidden: false, secondaryButton: 'Back', primaryButton: 'Confirm' },
        { title: 'Subscription Successful!', hidden: true, primaryButton: null },
        { title: 'Payment Unsuccessful', hidden: true, primaryButton: null }
      ]
    },
    totalPriceAmount () {
      if (!this.selectedContract) return 0
      let totalPrice = this.selectedContract.data.price
      this.selectedContract.data.add_ons.forEach(addOn => {
        if (addOn.selected) {
          totalPrice += addOn.price
        }
      })
      return totalPrice
    }
  },
  watch: {
    selectedContract (val) {
      if (val.data.billing_cycle === 'monthly' && this.selectedPaymentMethod == 'fpx') {
        this.selectedPaymentMethod = 'card'
      }
    }
  },
  mounted () {
    this.fetchCompany()

    if (this.paymentCallback) {
      if (this.paymentCallback.success) {
        this.step = 4
      } else {
        this.step = 5
      }
    }

    this.$axios.get(`/books/${this.company.slug}/statistics`)
      .then(resp => {
        this.statistics = resp.data
      })
      .catch(() => {})
  },
  methods: {
    ...mapActions([
      'showMessage',
      'updateCompany'
    ]),
    selectContract(contract) {
      this.contracts.forEach(c => {
        if (c.data.code === contract.data.code) {
          c.selected = true
          this.selectedContract = c
        } else {
          c.selected = false
        }
      })
    },
    previousStep () {
      if (this.step === 0) {
        this.dialog = false
      } else {
        this.step--
      }
    },
    nextStep () {
      if (this.step === this.steps.length - 1) return

      if (this.step === 0) {
        this.step++
        if (!this.planGroup) {
          this.isFetching = true
          this.$axios.get(`/subscription/plan_groups/YZ_CMS`)
            .then(resp => {
              console.log(resp.data)
              this.planGroup = resp.data
              const plansStructure = this.planGroup.extra_data[this.planVersion]
              this.contracts = []
              plansStructure.forEach((structure) => {
                this.planGroup.plans.forEach((plan) => {
                  plan.contracts.forEach((contract) => {
                    if (structure.code === contract.code) {
                      const newContract = {
                        selected: false,
                        data: contract
                      }
                      if (contract.extra_data.launch_promo_discount && !this.cmsSubscription.value) {
                        newContract.data.original_price = newContract.data.price
                        newContract.data.price = newContract.data.original_price - contract.extra_data.launch_promo_discount.discount_amount
                        newContract.data.confirm_promo_description = contract.extra_data.launch_promo_discount.description
                      } else {
                        newContract.data.original_price = newContract.data.price
                      }
                      this.contracts.push(newContract)
                    }
                  })
                })
              })
              this.contracts[0].selected = true
              this.selectedContract = this.contracts[0]
            })
            .catch(() => {})
            .finally(() => {
              this.isFetching = false
            })
        }
        return
      }

      if (this.step === 2) {
        if (!this.selectedPaymentMethod) {
          this.showMessage(['error', 'Please select payment method'])
          return
        }
      }

      if (this.step === 3) {
        this.form.contract = this.selectedContract.data.code
        this.form.add_ons = []
        this.selectedContract.data.add_ons.forEach(addOns => {
          if (addOns.selected) {
            const item = {
              feature: addOns.feature.code,
              count: 1
            }
            this.form.add_ons.push(item)
          }
        })
        this.isLoading = true
        this.$axios.post(`/subscription/subscriptions/${this.cmsTrial.data.id}/cancel/`, {})
          .catch(() => {})
          .finally(() => {
            if (this.selectedPaymentMethod === 'card') {
              this.subscribeByCard()
            } else if (this.selectedPaymentMethod === 'fpx') {
              this.subscribeByFpx()
            }
          })
      } else {
        this.step++
      }
    },
    subscribeByCard () {
      this.isLoading = true
      this.form.fbq = {
        cookies: Cookies.get(),
        user_agent: navigator.userAgent
      }
      this.$axios.post(`/subscription/subscriptions/`, this.form)
        .then(resp => {
          this.$axios.post(`/subscription/bills/${resp.data.bill}/charge_card/`, this.form)
            .then(() => {
              this.$emit('subscribed')
              this.fetchCompany()
              this.step++
              this.trackGtag()
            })
            .catch(() => {
              this.showMessage(['error', 'Unable to subscribe. Please try different card or contact our support team.'])
            })
            .finally(() => {
              this.isLoading = false
            })
        })
        .catch(() => {
          this.showMessage(['error', 'Unable to subscribe. Please try different card or contact our support team.'])
          this.isLoading = false
        })
    },
    subscribeByFpx () {
      this.isLoading = true
      if (this.company.currency.currency_code === 'IDR') {
        this.form.method = 'xendit'
      } else {
        this.form.method = 'laravel'
      }
      this.form.bank_code = this.fpxBankCode
      this.form.fbq = {
        cookies: Cookies.get(),
        user_agent: navigator.userAgent
      }
      this.$axios.post(`/subscription/subscriptions/`, this.form)
        .then(resp => {
          this.$axios.post(`/subscription/bills/${resp.data.bill}/request_manual_payment/`, this.form)
            .then(resp => {
              const data = resp.data
              setTimeout(() => {
                location.href = data.bill_url
              }, 1000)
            })
            .catch(() => {
              this.showMessage(['error', 'Unable to subscribe. Please try different method or contact our support team.'])
              this.isLoading = false
            })
        })
        .catch(() => {
          this.showMessage(['error', 'Unable to subscribe. Please try different method or contact our support team.'])
          this.isLoading = false
        })
    },
    fetchCompany () {
      this.$axios.get(`/companies/${this.company.id}/`)
        .then(resp => {
          this.updateCompany(resp.data)
        })
        .catch(() => {})
    },
    retryPayment () {
      this.retryPaymentLoading = true
      location.href = `${process.env.VUE_APP_BILLPLZ_URL}/bills/${this.paymentCallback.billId}?auto_submit=true`
    },
    trackGtag () {
      setOptions({
        config: { id: process.env.VUE_APP_YEZZA_GTAG_ID }
      })
      bootstrap().then(() => {
        this.$gtag.linker({
          'domains': ['yezza.com', 'yezza.io']
        })
        this.$gtag.purchase({
          'value': this.totalPriceAmount
        })
      })
    },
    finish () {
      this.dialog = false
      let baseDomain
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        baseDomain = `http://${window.location.host}`
      } else {
        baseDomain = `https://${process.env.VUE_APP_BASE_DOMAIN}`
      }
      document.location.href = `${baseDomain}/admin/dashboard`
    },
  }
}
</script>

<style lang="scss" scoped>
.colbox {
  border: 1px solid var(--v-primary400);
  background-color: var(--v-basic200);
  border-radius: 5px;
  text-align: center;
  padding-top: 3px;
  margin-left: 4px;
  margin-right: 4px;
  height: 32px;
  width: 60px;
}

.v-card.payment-method-selected {
  border-color: #D11184;
}

.separator {
  position: absolute;
  height:2px;
  top: 38px;
  left: 0px;
  right: 0px;
}
</style>
